var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoStandardSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 188,
    viewBox: "0 0 286 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.583 6.66638V16.2818C218.583 17.9172 217.933 19.4857 216.777 20.6421C215.621 21.7985 214.052 22.4482 212.417 22.4482H88.6664C87.031 22.4482 85.4625 23.0979 84.3061 24.2543C83.1497 25.4107 82.5 26.9792 82.5 28.6146V169.259C82.5 170.894 83.1497 172.463 84.3061 173.619C85.4625 174.775 87.031 175.425 88.6664 175.425H279.334C280.969 175.425 282.537 174.775 283.694 173.619C284.85 172.463 285.5 170.894 285.5 169.259V6.66638C285.5 5.03096 284.85 3.46252 283.694 2.3061C282.537 1.14968 280.969 0.5 279.334 0.5H224.752C223.942 0.49973 223.14 0.659027 222.391 0.968796C221.643 1.27856 220.963 1.73274 220.39 2.30537C219.817 2.87799 219.363 3.55786 219.053 4.30614C218.743 5.05441 218.583 5.85643 218.583 6.66638Z",
    fill: "url(#paint0_linear_1762_61288)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1762_61288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 57.5,
    width: 206,
    height: 80,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 58.5,
    width: 204,
    height: 78,
    rx: 15,
    stroke: "#EEF2F6",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 73.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 73.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F8FAFC",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8997 89.1015V99.9015H56.8997V105.902H46.0997V89.1015H62.8997ZM62.8997 86.7015H46.0997C44.7797 86.7015 43.6997 87.7815 43.6997 89.1015V105.902C43.6997 107.222 44.7797 108.302 46.0997 108.302H58.0997L65.2997 101.102V89.1015C65.2997 87.7815 64.2197 86.7015 62.8997 86.7015ZM54.4997 99.9015H48.4997V97.5015H54.4997V99.9015ZM60.4997 95.1015H48.4997V92.7015H60.4997V95.1015Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 73.5,
    width: 102,
    height: 12,
    rx: 6,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 97.5,
    width: 102,
    height: 12,
    rx: 6,
    fill: "#EEF2F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1762_61288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 96.5,
    width: 206,
    height: 80,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 97.5,
    width: 204,
    height: 78,
    rx: 15,
    stroke: "#EEF2F6",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 112.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 112.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F8FAFC",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9 128.102V138.902H94.8997V144.902H84.0997V128.102H100.9ZM100.9 125.702H84.0997C82.7797 125.702 81.6997 126.782 81.6997 128.102V144.902C81.6997 146.222 82.7797 147.302 84.0997 147.302H96.0997L103.3 140.102V128.102C103.3 126.782 102.22 125.702 100.9 125.702ZM92.4997 138.902H86.4997V136.502H92.4997V138.902ZM98.4997 134.102H86.4997V131.702H98.4997V134.102Z",
    fill: "#9AA4B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 118.5,
    width: 102,
    height: 12,
    rx: 6,
    fill: "#EEF2F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 142.5,
    width: 77,
    height: 12,
    rx: 6,
    fill: "#EEF2F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1762_61288",
    x: 0.5,
    y: 48.5,
    width: 226,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411538 0 0 0 0 0.55 0 0 0 0 0.688462 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1762_61288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1762_61288",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1762_61288",
    x: 38.5,
    y: 87.5,
    width: 226,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411538 0 0 0 0 0.55 0 0 0 0 0.688462 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1762_61288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1762_61288",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1762_61288",
    x1: 184,
    y1: 0.5,
    x2: 184,
    y2: 175.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoStandardSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no_standard_selected.7ae13bb67c6983ac8f971c401fa45fa5.svg";